import { useState } from "react";

import { Trash } from "lucide-react";
import { useDispatch } from "react-redux";

import { CaseSchema } from "@/api/generated/types.gen";
import { useDeleteCase } from "@/hooks/mutations/use-cases";
import { setMessage } from "@/redux/notification";

import DeleteIcon from "@assets/images/file-with-trash.png";

import { ConfirmationModal } from "../../ConfirmationModal";
import { Button } from "../../ui/button";

type DeleteCaseConfirmationProps = {
  caseItem: CaseSchema;
};
export const DeleteCaseConfirmation = ({
  caseItem,
}: DeleteCaseConfirmationProps) => {
  const dispatch = useDispatch();
  const deleteCase = useDeleteCase();

  const [isOpen, setIsOpen] = useState(false);

  const handleDelete = () => {
    deleteCase.mutate(caseItem.id, {
      onSuccess: () => {
        dispatch(
          setMessage({
            content: `Case ${caseItem.case_number} deleted successfully`,
            type: "success",
          })
        );
        setIsOpen(false);
      },
      onError: error => {
        dispatch(
          setMessage({
            content: error.message || "Failed to delete case",
            type: "error",
          })
        );
      },
    });
  };

  return (
    <ConfirmationModal
      type="warning"
      icon={
        <img
          src={DeleteIcon}
          alt="Delete Icon"
          className="size-14 text-destructive"
        />
      }
      title="Delete Selected Case?"
      description="This action will permanently delete the selected case and cannot be undone. Please confirm to proceed."
      confirmButtonText="Yes, Delete"
      cancelButtonText="No, Cancel"
      onConfirm={handleDelete}
      isLoading={deleteCase.isPending}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Button
        variant="ghost"
        size="sm"
        className="p-2"
        disabled={deleteCase.isPending}
        onClick={() => setIsOpen(true)}
      >
        <Trash className="size-4 text-destructive" />
      </Button>
    </ConfirmationModal>
  );
};
